import { useRoutes } from 'react-router-dom'
import { appRouteObjects } from '@/router/appRoutes.config'

// Bir sekmenin kendi MemoryRouter'ı içinde, web ile aynı korumalı modül route'larını
// render eder (tek kaynak: appRouteObjects). Konum, sekmenin kendi MemoryRouter
// geçmişinden gelir → her sekmenin geri/ileri davranışı izoledir.
export default function AppRoutes() {
  return useRoutes(appRouteObjects)
}
